import Layout from '../views/layout/Layout'

export default {
  path: '/report',
  component: Layout,
  // redirect: '/report/index',
  name: 'report',
  meta: {title: '调养方案', icon: 'data-center'},
  children: [
    {
      path: 'list',
      name: 'list',
      component: () => import('@/views/report/list/index'),
      meta: {title: '模板列表', icon: 'constitution'}
    },
    {
      path: 'index',
      name: 'index',
      component: () => import('@/views/report/index'),
      meta: {title: '富文本工具', icon: 'constitution'}
    },
    {
      path: 'manage',
      name: 'manage',
      component: () => import('@/views/report/manage/index.vue'),
      meta: {title: '报告管理', icon: 'constitution'}
    },
    // /*
    {
      path: 'pdfEditor',
      name: 'pdfEditor',
      component: () => import('@/views/report/pdfEditor/index'),
      meta: {title: 'pdf编辑', icon: 'constitution'},
      hidden: true,
    },
    // */
    {
      path: 'template',
      name: 'template',
      component: () => import('@/views/report/template/index'),
      meta: {title: '修改模板'},
      hidden: true,
    },
    {
      path: 'json',
      name: 'json',
      component: () => import('@/views/report/json/index'),
      meta: {title: '修改JSON模板'},
      hidden: true,
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/report.js